import { User } from "../models/User";

type AccessHeaderFn = (addContentType?: boolean) => Promise<Headers>;

export async function fetchCurrentUser(
  getAccessHeader: AccessHeaderFn,
): Promise<User | null> {
  try {
    const response = await fetch("/api/me", {
      method: "GET",
      headers: await getAccessHeader(),
    });

    if (response.status !== 200) {
      console.error(response.status);
      return null;
    }

    const data = await response.json();

    return {
      isSuperAdmin: data.user_roles.indexOf("superadmin") > -1,
      isAdmin: data.user_roles.indexOf("admin") > -1,
      isOperator: data.user_roles.indexOf("operator") > -1,
      firstName: data.user_first_name,
      lastName: data.user_last_name,
      tenantId: data.tenant_id,
      roles: data.user_roles,
    };
  } catch (error) {
    console.error(error);
    return null;
  }
}
